export const IndeedCampaignsRoutes = [
    {
        "url": "/indeed-campaigns",
        "name": "appLayout.harriSH.access-portal.indeed-campaigns",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/indeed-campaigns/indeed-campaigns.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['indeed-campaigns'],
        },
    },
    {
        "url": "/view-indeed-campaign/:id",
        "name": "appLayout.harriSH.access-portal.view-indeed-campaign",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/indeed-campaigns/indeed-campaigns.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['indeed-campaigns'],
        },
    },
    {
        "url": "/create-campaign",
        "name": "appLayout.harriSH.access-portal.create-campaign",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/indeed-campaigns/indeed-campaigns.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['indeed-campaigns'],
        },
    },
];
//# sourceMappingURL=indeed-capaigns.routes.js.map